import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 48px 24px;
  text-align: center;
  border: 1px dashed ${({ theme }) => theme.borderColor};
  border-radius: 10px;
  background-color: ${({ theme }) => theme.cardBackground};
`;

export const Icone = styled.div`
  font-size: 34px;
  line-height: 1;
  color: ${({ theme }) => theme.darkGray};
  opacity: 0.7;
`;

export const Titulo = styled.p`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.textColor};
`;

export const Descricao = styled.p`
  margin: 0;
  max-width: 420px;
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => theme.darkGray};
`;

export const Acao = styled.div`
  margin-top: 4px;
`;
